<template>
    <div>
        <div class="messageBox">
            <div class="message">
                <img src="../../../assets/img/headPortrait.png" alt="">
                <h1>{{exhibition.company_name}}</h1>
                <p>统一社会信用代码：{{exhibition.org_idcardnum}}</p>
                <p>可用余额（元）：{{exhibition.keyong_money}}元</p>
                <div>已认证</div>
            </div>
            <div class="representativeBox">
                <div class="representative">
                    <img src="../../../assets/img/representative.png" alt="">
                    <div class="certificate">
                        <p>法定代表人: {{exhibition.legal_repname}}</p>
                        <span>证件号：{{exhibition.legal_repidcardnum}}</span>
                    </div>
                    <div class="change">
                    </div>
                </div>
                <div class="administrator">
                    <img src="../../../assets/img/administrator.png" alt="">
                    <div class="certificate">
                        <p>公司省份：{{exhibition.sheng_name}}</p>
                        <p>公司地址：{{exhibition.company_address}}</p>
                        <span>公司邮箱：{{exhibition.email}}</span>
                    </div>
                    <div class="change" >
                      <el-button class="customize" @click="modifyBtn">修改</el-button>
                    </div>
                </div>
            </div>

            <div class="employeesBox">
                <div class="employees">
                    <img src="../../../assets/img/employees.png" alt="">
                    <div class="certificate">
                        <p>
                            我的身份：
                            <span v-if="exhibition.user_type==2">企业管理员</span>
                            <span v-if="exhibition.user_type==3">企业员工</span>
                        </p>
                        <span>企业员工数：{{exhibition.yuangong_num}}人</span>

                    </div>
                    <div class="examine">
                    </div>
                </div>
                <div class="section">
                    <img src="../../../assets/img/departmentNumber.png" alt="">
                    <div class="certificate">
                        <p v-if="exhibition.contract_num != 0">剩余合同份数：{{exhibition.contract_num}}份</p>
                        <span>已用合同份数：{{exhibition.used_contract_num}}份</span>
                        <p style="margin-top: 5px" v-if="exhibition.end_time!=''">到期日：{{exhibition.end_time}}</p>
                    </div>
                    <div class="examine" >
                    </div>
                </div>
            </div>
        </div>
        <!--            修改公司地址、公司邮箱-->
        <el-dialog
                title="修改信息"
                :visible.sync="dialogVisible"
                :close-on-click-modal="false"
                width="30%">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
                <el-form-item label="公司所在省份" prop="provinceValue">
                    <el-select  v-model="ruleForm.sheng_code" placeholder="请选择公司所在省份">
                        <el-option
                                v-for="item in options"
                                :key="item.code"
                                :label="item.name"
                                :value="item.code">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="公司地址" prop="company_address">
                    <el-input v-model="ruleForm.company_address" style="width: 85%"></el-input>
                </el-form-item>
                <el-form-item label="公司邮箱" prop="email">
                    <el-input v-model="ruleForm.email" style="width: 85%"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="confirmBtn">确 定</el-button>
                </span>
        </el-dialog>
    </div>
</template>

<script>
    import { enterpriseInformation, getProvinces, modifyEnterprise } from '../../../api/personal';

    export default {
        name: "management",
        inject:['reload'],
        data(){
            return{
                exhibition:{},
                dialogVisible:false,  //修改
                options:[], //省份数组
                ruleForm:{
                    provinceValue:'',//省份
                    company_address:'',
                    email:'',
                },
                rules:{
                    provinceValue:[
                        {required: true, message: '请选择公司所在省份', trigger: 'blur' }
                    ],
                    company_address:[
                        {required: true, message: '请输入公司地址', trigger: 'blur' }
                    ],
                    email:[
                        {required: true, message: '请输入公司邮箱', trigger: 'blur' }
                    ]
                }
            }
        },
        methods:{
            //修改公司地址 公司邮箱
            confirmBtn(){
                modifyEnterprise(this.ruleForm.company_address,this.ruleForm.email,this.ruleForm.sheng_code).then(res=>{
                    if (res.code==200){
                        this.$message.success(res.msg)
                        this.reload()
                    }else {
                        this.$message.error(res.msg)
                    }
                })
            },
            //修改公司信息
            modifyBtn(){
                getProvinces().then(res=>{
                    if (res.code==200){
                        this.options=res.data.list
                    }else {
                        this.$message.error(res.msg)
                    }
                })
                this.dialogVisible=true
            }
        },
        created() {
            enterpriseInformation().then(res=>{
                this.exhibition=res.data
                this.ruleForm=res.data
            })
        }
    }
</script>

<style scoped>
    .messageBox{

        margin: 10px;
        padding: 30px;
        background-color: #fff;
        border-radius: 5px;
    }
    .message{
        padding: 30px;
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .message>img{
        width: 100px;
        height: 100px;
    }
    .message>h1{
        margin: 20px 0px;
    }
    .message>p{
        margin-bottom: 20px;
        color: #a5a5a7;
    }
    .message>div{
        width: 80px;
        background-color: #3e62f6;
        color: #fff;
        text-align: center;
        border-radius: 5px;
        height: 30px;
        line-height: 30px;
    }
    .representativeBox{
        color: #5e5e60;
        display: flex;
        margin: 20px;
    }
    .representative,
    .administrator{
        margin: 0px 10px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 50%;
        border-radius: 10px;
        padding: 30px;
        border: 1px solid #9e9ea0;
    }
    .change{
        width: 80px;
        height: 30px;
        line-height: 30px;
        border-radius: 5px;
        text-align: center;
        color: #3e62f8;
    }
    .certificate{
        width: 65%;
    }
    .certificate>P{
        margin-bottom: 5px;
        overflow:hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    .employeesBox{
        color: #5e5e60;
        margin: 20px;
        display: flex;
    }
    .employees,
    .section{
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 10px;
        width: 50%;
        padding: 30px;
        border: 1px solid #9e9ea0;
        border-radius: 10px;
    }
    .quantity,
    .department{
        width: 65%;
    }
    .examine{
        width: 80px;
        height: 30px;
        line-height: 30px;
        color: #3e62f8;
        text-align: center;
        border-radius: 5px;
    }
    .customize{
        background-color: #3e62f6;
        color: #fff;
        border-radius: 5px;
        font-size: 14px;
    }
    /deep/.el-select{
        width: 85%;
    }
</style>
